export const UI = {
  zh: {
    htmlLang: 'zh-CN',
    title: 'PT Sites · 站点导航',
    headerStatus: (count) => `${count} 个站点 · 智能搜索`,
    loadingDirectory: '正在装载站点目录',
    eyebrow: 'PT 站点导航',
    heroTitle: '搜索站点与资源',
    heroBody: '输入站名、常用称呼，或直接描述你想找的内容。',
    searchLabel: '搜索站点',
    searchPlaceholder: '搜索站名、别名、4K 原盘、动漫、音乐…',
    indexLoadingPlaceholder: '正在加载站点目录…',
    clearSearch: '清空搜索',
    recommendationsLabel: '搜索灵感',
    shuffleRecommendations: '换一批',
    shuffleRecommendationsLabel: '换一批搜索推荐',
    recommendationGroups: {
      sites: [
        '馒头', '猫站', '天空', '彩虹岛', '春天', '朋友站', '我堡', '观众',
        '憨憨', '皇后', '幼儿园', '海豚', '北邮人', '葡萄', '二师兄', '包子',
        '星云', 'B站PT', '比特蜂巢', '熊猫高清', '朱雀', '咖啡PT', '聆音', '海棠PT',
      ],
      content: [
        '电影', '电视剧', '动漫', '纪录片', '无损音乐', '电子书与漫画', '有声书',
        '游戏', '体育赛事', 'F1 赛车', '少儿动画', 'macOS 软件', '演唱会', '国漫',
        '韩剧', '日剧', '曲艺', '技术学习资料',
      ],
      quality: [
        '4K 原盘', '蓝光原盘', 'Remux', 'WEB-DL', '小体积压制', 'x265 / HEVC',
        'DIY 原盘', '国语配音', '特效字幕', '杜比视界', '杜比全景声', '母带音频',
        'CD 抓轨', '经典黑胶', 'FANRES', '冷门艺术电影', '经典动画', '站内发布组',
        '0-Day', '无分享率',
      ],
      community: [
        '开放注册', '开放邀请', '邀请制', '适合新手', '高校教育网', 'IPv6 高校站',
        '华语社区', '海外社区', '十二大', '传统九大', '外站影视三强', '皮妞堡',
        'PT 交流论坛', 'NAS 社区',
      ],
    },
    textReady: '智能搜索正在准备',
    semanticLoading: '首次访问需要片刻，当前为普通搜索；准备完成后会自动增强搜索结果。',
    semanticReady: '智能搜索已开启',
    semanticDetails: () => '现在可以直接描述想找的资源或站点特点。',
    semanticFailed: '智能搜索暂未开启，普通搜索仍可正常使用。',
    indexLoading: '正在准备站点资料…',
    directory: '站点一览',
    directoryTitle: '站点目录',
    anniversaryEyebrow: '周年日历',
    anniversaryTitle: '近期站庆',
    anniversaryWindow: (days, count) => `未来 ${days} 天 · ${count} 个站点`,
    anniversaryCountdown: (days, years) => years === 0
      ? (days === 0 ? '今天开站' : `${days} 天后开站`)
      : (days === 0 ? `今天 · ${years} 周年` : `${days} 天后 · ${years} 周年`),
    resultTitle: (query) => `“${query}” 的结果`,
    circle: '站点范围',
    resourceDirection: '资源方向',
    circleNote: '内站与外站按主要服务人群和社区语言划分，不代表服务器所在地。',
    all: '全部',
    resultCount: (count) => `找到 ${count} 条记录`,
    indexErrorTitle: '站点资料加载失败',
    indexErrorBody: '请刷新页面重试。',
    emptyTitle: '没有匹配的站点',
    emptyBody: '换个描述，或清除分类筛选后再试。',
    loadMore: (count) => `继续查看 ${count} 个站点`,
    openDetails: (name) => `查看 ${name} 详情`,
    match: (score) => `匹配度 ${score}%`,
    nameMatch: '名称匹配',
    textMatch: '文字匹配',
    close: '关闭详情',
    introduction: '站点简介',
    resources: '资源与特色',
    communityLabels: '圈内标签',
    filterByLabel: (label) => `筛选标签：${label}`,
    releaseGroups: '站内发布组',
    tips: '入门提示',
    language: '语言',
    sourceCount: '参考资料',
    serviceType: '站点形式',
    research: '资料状态',
    siteStatus: '站点状态',
    siteAlive: '存活',
    siteDown: '异常',
    siteDead: '已死亡',
    siteUnknown: '待确认',
    foundedAt: '建站日期',
    foundedShort: (date) => `建站 ${date}`,
    closedAt: '关站日期',
    closedShort: (date) => `关站 ${date}`,
    closedDateUnknown: '关站日期未收录',
    nextAnniversary: '下次站庆',
    monitorSource: '状态来源',
    monitorObserved: (time) => `SavePT · ${time}`,
    checkedAt: '核对日期',
    visit: '访问站点',
    sourceLink: (index) => `参考资料 ${index}`,
    footer: '站点资料持续整理中，开放状态和规则可能变化，请以各站公告为准。',
    visitStats: '站点访问统计',
    totalVisits: '总访问量',
    todayVisits: '今日访问量',
    themeLabel: '主题色',
    themeNames: { ocean: '薄荷苏打', blue: '星海蓝', amber: '蜜糖橙', rose: '樱花粉' },
  },
  en: {
    htmlLang: 'en',
    title: 'PT Sites · Site guide',
    headerStatus: (count) => `${count} sites · smart search`,
    loadingDirectory: 'Loading the site directory',
    eyebrow: 'PT site guide',
    heroTitle: 'Search sites and content',
    heroBody: 'Enter a site name, nickname, or simply describe what you want.',
    searchLabel: 'Search sites',
    searchPlaceholder: 'Search a name, nickname, 4K discs, anime, music…',
    indexLoadingPlaceholder: 'Loading the site directory…',
    clearSearch: 'Clear search',
    recommendationsLabel: 'Search ideas',
    shuffleRecommendations: 'Shuffle',
    shuffleRecommendationsLabel: 'Show different search ideas',
    recommendationGroups: {
      sites: [
        'M-Team', 'PterClub', 'HDSky', 'CHDBits', 'OurBits', 'OpenCD', 'U2',
        'TTG', 'PTP', 'BTN', 'HDBits', 'Redacted', 'Orpheus', 'AnimeBytes',
        'GazelleGames', 'TorrentLeech', 'FileList', 'BeyondHD', 'Blutopia', 'Aither',
        'MoreThanTV', 'OldToonsWorld', 'iAnon', 'SportsCult',
      ],
      content: [
        'Movies', 'TV series', 'Anime & manga', 'Documentaries', 'Lossless music',
        'eBooks & comics', 'Audiobooks', 'Games', 'Sports', 'Kids animation',
        'macOS / iOS apps', 'E-learning', 'Concerts', 'Chinese animation',
        'Korean dramas', 'Japanese dramas', 'F1 racing', 'Software',
      ],
      quality: [
        '4K / UHD', 'Blu-ray full discs', 'Remux', 'WEB-DL', 'Compact x265 encodes',
        'DIY Blu-rays', 'Dubbed audio', 'Styled subtitles', 'Dolby Vision', 'Dolby Atmos',
        'Hi-Res audio', 'Vinyl & CD rips', 'Fan restorations', 'Rare arthouse films',
        'Classic animation', 'Internal release groups', '0-Day', 'Ratioless',
        'Full disc archives', 'High-quality encodes',
      ],
      community: [
        'Open signup', 'Invites available', 'Invite only', 'Beginner-friendly',
        'University / IPv6', 'Chinese-language trackers', 'International trackers',
        'Top 12 Chinese trackers', 'Traditional Nine', 'Top movie & TV trackers',
        'PT community forums', 'NAS community',
      ],
    },
    textReady: 'Smart search is getting ready',
    semanticLoading: 'The first visit takes a moment. Standard search is available now, and results will improve automatically.',
    semanticReady: 'Smart search is on',
    semanticDetails: () => 'Describe the content or site qualities you are looking for.',
    semanticFailed: 'Smart search is not available right now. Standard search still works.',
    indexLoading: 'Preparing the site directory…',
    directory: 'Browse sites',
    directoryTitle: 'Site directory',
    anniversaryEyebrow: 'Anniversary calendar',
    anniversaryTitle: 'Coming anniversaries',
    anniversaryWindow: (days, count) => `Next ${days} days · ${count} ${count === 1 ? 'site' : 'sites'}`,
    anniversaryCountdown: (days, years) => {
      if (years === 0) return days === 0 ? 'Opens today' : `Opens in ${days} ${days === 1 ? 'day' : 'days'}`;
      return days === 0 ? `Today · ${years}-year anniversary` : `In ${days} ${days === 1 ? 'day' : 'days'} · ${years} years`;
    },
    resultTitle: (query) => `Results for “${query}”`,
    circle: 'Site scope',
    resourceDirection: 'Content focus',
    circleNote: 'Inner and outer refer to the audience and community language, not server location.',
    all: 'All',
    resultCount: (count) => `${count} records`,
    indexErrorTitle: 'The site directory could not be loaded',
    indexErrorBody: 'Please refresh the page and try again.',
    emptyTitle: 'No matching sites',
    emptyBody: 'Try another description or clear the filters.',
    loadMore: (count) => `Show ${count} more sites`,
    openDetails: (name) => `View details for ${name}`,
    match: (score) => `${score}% match`,
    nameMatch: 'Name match',
    textMatch: 'Text match',
    close: 'Close details',
    introduction: 'Overview',
    resources: 'Content and specialties',
    communityLabels: 'Community labels',
    filterByLabel: (label) => `Filter by label: ${label}`,
    releaseGroups: 'Release groups',
    tips: 'Access notes',
    language: 'Language',
    sourceCount: 'References',
    serviceType: 'Site format',
    research: 'Research status',
    siteStatus: 'Site status',
    siteAlive: 'Active',
    siteDown: 'Degraded',
    siteDead: 'Closed',
    siteUnknown: 'Unknown',
    foundedAt: 'Founded',
    foundedShort: (date) => `Founded ${date}`,
    closedAt: 'Closed',
    closedShort: (date) => `Closed ${date}`,
    closedDateUnknown: 'Closure date unavailable',
    nextAnniversary: 'Next anniversary',
    monitorSource: 'Status source',
    monitorObserved: (time) => `SavePT · ${time}`,
    checkedAt: 'Checked',
    visit: 'Visit site',
    sourceLink: (index) => `Reference ${index}`,
    footer: 'Site information is continuously reviewed. Availability and rules can change; check each site for current details.',
    visitStats: 'Site visit statistics',
    totalVisits: 'Total views',
    todayVisits: 'Views today',
    themeLabel: 'Theme color',
    themeNames: { ocean: 'Mint soda', blue: 'Starlight blue', amber: 'Honey orange', rose: 'Sakura pink' },
  },
};

const RESOURCE_EN = {
  '综合': 'General', '影视': 'Movies / TV', '动漫': 'Anime', '音乐': 'Music', '图书': 'Books / comics',
  '学习': 'Learning', '体育': 'Sports', '游戏': 'Games', '软件': 'Software', '少儿': 'Kids',
  '成人': 'Adult', '论坛资讯': 'Forum / news', '其他': 'Other',
};

const COMMUNITY_EN = {
  '十二大': 'Top 12', '传统九大': 'Traditional Nine', '历史五大公网': 'Historic Public Five',
  '历史三大': 'Historic Big Three', '外站影视三强': 'Top 3 international video sites',
  '皮妞堡': 'PTP · BTN · HDB trio', '高校站': 'University tracker', '音乐专站': 'Music specialist',
  '成人专站': 'Adult specialist',
};

const STATUS_EN = {
  '仅限捐赠': 'Donation only',
  '开放邀请': 'Invites available',
  '权贵邀请': 'Restricted invites',
  '跑路中...': 'Offline / closed',
  '邀请制（偶尔开放注册）': 'Invite only; occasionally open',
  '邀请制/阶段性开放（以论坛当前策略为准）': 'Invite or limited open signup',
};

const TERM_EN = {
  '电影': 'Movies', '电视剧/电视节目': 'TV', '综艺': 'Variety shows', '纪录片': 'Documentaries',
  '动漫': 'Anime', '动画电影': 'Animated movies', '动画剧集': 'Animated series', '国漫': 'Chinese animation',
  '音乐': 'Music', '音乐视频/演唱会': 'Music videos / concerts', '演唱会': 'Concerts', '原声音乐': 'Soundtracks',
  '体育': 'Sports', '赛车赛事': 'Motorsports', '游戏': 'Games', '软件': 'Software', 'macOS/iOS 软件': 'macOS / iOS software',
  '电子书': 'eBooks', '电子书/漫画': 'eBooks / comics', '图书': 'Books', '书籍': 'Books', '文学': 'Literature',
  '有声书': 'Audiobooks', '有声小说': 'Audio fiction', '学习资料': 'Learning material', '技术/E-Learning': 'Tech / e-learning',
  '少儿': 'Kids', '成人': 'Adult', '影视': 'Movies / TV', '综合': 'General', '综合索引': 'General index',
  '短剧': 'Short dramas', '教程': 'Tutorials', '教育': 'Education', '自然': 'Nature', '音频': 'Audio',
  '冷门': 'Rare content', '低分': 'Low-rated titles', '粤语': 'Cantonese', '中文': 'Chinese', '韩剧': 'Korean dramas', '日剧': 'Japanese dramas',
  '曲艺': 'Traditional performance', '小品': 'Sketch comedy', 'PT交流': 'PT discussion', '站点资讯': 'Tracker news',
  '邀请与开放信息': 'Invites and open signup', '0-Day': '0-Day', 'FANRES': 'Fan restorations', 'NAS': 'NAS',
  '站内发布组': 'Internal release groups', '无分享率制': 'Ratioless', '无损音乐': 'Lossless music',
  '小体积高清压制': 'Compact HD encodes', '小体积高画质': 'Compact high-quality encodes', '压制': 'Encodes',
  '原盘': 'Full discs', '原盘/光盘专站': 'Disc-focused', '原盘与高规格发布': 'Full discs and high-spec releases',
  '高清影视': 'HD movies / TV', '高清/UHD 影视': 'HD / UHD movies and TV', '高品质影视': 'High-quality video',
  '电影专站': 'Movie-focused', '剧集专站': 'TV-focused', '音乐专站': 'Music-focused', '动漫专站': 'Anime-focused',
  '游戏专站': 'Game-focused', '体育专站': 'Sports-focused', '成人专站': 'Adult-focused',
  '少儿/儿童资源': 'Kids content', '冷门与艺术电影': 'Rare and arthouse films', '多版本归档': 'Multi-version archive',
  '法语高清影视': 'French HD video', '俄语高清影视': 'Russian HD video', '罗马尼亚综合站': 'Romanian general tracker',
  '巴西综合内容': 'Brazilian general content', '拉美/西语内容': 'Latin American / Spanish content',
  'PT论坛': 'PT forum', '社区问答': 'Community Q&A', '经验讨论': 'Experience sharing', '非 tracker': 'Not a tracker',
  '技术与学习资料': 'Tech and learning material', '音乐与文学': 'Music and literature', '影视与音乐': 'Video and music',
  '电影与剧集': 'Movies and TV', '综合内容': 'General content', '经典动画': 'Classic animation',
  '面试渠道': 'Interview access', '授权发布': 'Authorized uploads', '教育网': 'Education network',
  '杜比视界': 'Dolby Vision', '杜比全景声': 'Dolby Atmos', '母带音频': 'Master audio', '经典黑胶': 'Vinyl',
  '站内发布组': 'Internal release groups', 'Usenet 索引': 'Usenet index', 'Usenet 发布社区': 'Usenet release community',
};

export const THEMES = [
  { id: 'ocean', color: '#147d78', background: '#eaf5f3' },
  { id: 'blue', color: '#426dcc', background: '#edf2ff' },
  { id: 'amber', color: '#ad6511', background: '#fff3dd' },
  { id: 'rose', color: '#bd4d73', background: '#fff0f4' },
];

export function detectTheme() {
  try {
    const saved = localStorage.getItem('pt-sites-theme');
    if (THEMES.some((theme) => theme.id === saved)) return saved;
  } catch {}
  return 'rose';
}

export function detectLanguage() {
  try {
    const saved = localStorage.getItem('pt-sites-language');
    if (saved === 'zh' || saved === 'en') return saved;
  } catch {}
  const browserLanguage = navigator.languages?.[0] || navigator.language || 'en';
  return browserLanguage.toLowerCase().startsWith('zh') ? 'zh' : 'en';
}

export function resourceCategoryLabel(value, language) {
  return language === 'en' ? RESOURCE_EN[value] || value : value;
}

export function statusLabel(value, language) {
  return language === 'en' ? STATUS_EN[value] || value : value;
}

export function termLabel(value, language) {
  if (language !== 'en') return value;
  return TERM_EN[value] || value;
}

export function circleLabel(value, language) {
  const labels = language === 'en'
    ? { inner: 'Inner · Chinese community', outer: 'Outer · International', other: 'Community / other' }
    : { inner: '内站 · 华语圈', outer: '外站 · 海外圈', other: '社区与其他' };
  return labels[value ?? 'other'];
}

export function serviceTypeLabel(value, language) {
  const labels = language === 'en'
    ? { pt_tracker: 'PT site', community_forum: 'Community forum', usenet_indexer: 'Resource index', usenet_community: 'Resource community' }
    : { pt_tracker: 'PT 站点', community_forum: '交流社区', usenet_indexer: '资源索引', usenet_community: '资源社区' };
  return labels[value] || value;
}

export function communityLabel(value, language) {
  return language === 'en' ? COMMUNITY_EN[value] || value : value;
}

export function researchLabel(value, language) {
  if (language !== 'en') return value;
  return ({ '多源交叉核对': 'Cross-checked', '公开资料已补充': 'Public sources added', '资料有限': 'Limited sources' })[value] || value;
}

export function siteLanguageLabel(value, language) {
  const labels = {
    'zh-CN': language === 'en' ? 'Chinese' : '中文',
    'en-US': language === 'en' ? 'English' : '英文',
    'ro-RO': language === 'en' ? 'Romanian' : '罗马尼亚语',
    'ru-RU': language === 'en' ? 'Russian' : '俄语',
    'pt-BR': language === 'en' ? 'Brazilian Portuguese' : '巴西葡萄牙语',
    'es-419': language === 'en' ? 'Latin American Spanish' : '拉美西班牙语',
    'es-MX': language === 'en' ? 'Spanish' : '西班牙语',
    'fr-FR': language === 'en' ? 'French' : '法语',
  };
  return labels[value] || value;
}

export function difficultyLabel(site, language) {
  if (language !== 'en') return site.difficulty;
  if (site.service_type !== 'pt_tracker') return 'Community or resource service';
  const level = site.community_profile?.join_difficulty;
  return level ? `Community-rated access: ${level.toLowerCase()}` : 'Check the current site rules';
}

export function siteDescription(site, language) {
  if (language !== 'en') {
    return site.features
      .replace(/站点架构为 F3NIX；?/gi, '')
      .replace(/，使用 (?:Luminance|UNIT3D|Gazelle) 架构并采用/gi, '，采用')
      .replace(/[，,]?使用 (?:Luminance|UNIT3D|Gazelle) 架构[；;，,。]?/gi, '。')
      .replace(/是基于 UNIT3D 的电影\/剧集站点/gi, '是以电影和剧集为主的站点')
      .replace(/是一个专注于音乐的中文 Gazelle 站点/gi, '是一个专注于音乐的中文站点')
      .replace(/是以 0-Day、Scene 与综合内容为主的 Gazelle 站点/gi, '以新鲜发布和综合内容为主')
      .replace(/基于 XenForo 的 Usenet\/NZB 发布社区/gi, '面向高清影视的独立资源社区')
      .replace(/是 Usenet\/Newznab 索引服务，不是 BitTorrent PT 站；使用时还需要 Usenet 服务商和支持 NZB 的下载客户端/gi, '采用独立于常规 PT 的资源获取方式，使用前需要准备对应的资源服务和下载工具')
      .replace(/它不是 BitTorrent PT tracker/gi, '它不使用常规 PT 下载方式')
      .replace(/校园Private Tracker/gi, '校园 PT 站')
      .replace(/并非提供种子下载与流量统计的 PT tracker/gi, '本身不提供 PT 资源下载')
      .replace(/。{2,}/g, '。');
  }
  const types = site.content_types.slice(0, 8).map((item) => termLabel(item, 'en'));
  const specialties = site.specialties.slice(0, 5).map((item) => termLabel(item, 'en'));
  if (site.service_type === 'community_forum') {
    return `${site.name} is a community for ${types.join(', ')}. It does not provide PT downloads.`;
  }
  if (site.service_type === 'usenet_indexer' || site.service_type === 'usenet_community') {
    return `${site.name} is a separate resource service focused on ${types.join(', ')}. It does not use the usual PT download system.`;
  }
  const coverage = types.length ? ` It covers ${types.join(', ')}.` : ' Public information about its content focus is limited.';
  const specialty = specialties.length ? ` Notable traits: ${specialties.join(', ')}.` : '';
  const groups = site.official_groups.length ? ` Recognized release groups include ${site.official_groups.slice(0, 8).join(', ')}.` : '';
  return `${site.name} is a private PT site.${coverage}${specialty}${groups}`;
}

export function siteAccessNote(site, language) {
  if (language !== 'en') return site.beginner_tips;
  if (site.service_type === 'usenet_indexer' || site.service_type === 'usenet_community') return 'This service may require a separate provider and a compatible download app. Check the site for current account and subscription rules.';
  if (site.service_type === 'community_forum') return 'Access may require an invitation or prior site history. Never share private account credentials.';
  const profile = site.community_profile;
  const rules = [statusLabel(site.registration, 'en')];
  if (profile?.ratio_required === true) rules.push('ratio required');
  if (profile?.ratio_required === false) rules.push('ratioless');
  if (profile?.hit_and_run === true) rules.push('H&R rules apply');
  return `${rules.join(' · ')}. Rules can change; read the current site rules before downloading.`;
}
